// Consent-gated analytics. Nothing here runs until analytics.ga4Id is set
// in src/data/site.js AND the visitor accepts the consent banner.
import { analytics } from "../data/site";

const KEY = "pepla-consent";
const hasWindow = typeof window !== "undefined";

export const analyticsConfigured = () => Boolean(analytics.ga4Id);

export const getConsent = () => {
  if (!hasWindow) return null;
  try { return window.localStorage.getItem(KEY); } catch { return null; }
};

export const setConsent = (value) => {
  try { window.localStorage.setItem(KEY, value); } catch { /* private mode */ }
  if (value === "granted") loadAnalytics();
};

let loaded = false;
const addScript = (src) => {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
};

export const loadAnalytics = () => {
  if (!hasWindow || loaded || !analyticsConfigured() || getConsent() !== "granted") return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  // SPA: page views are sent manually on route change
  window.gtag("config", analytics.ga4Id, { send_page_view: false, anonymize_ip: true });
  addScript(`https://www.googletagmanager.com/gtag/js?id=${analytics.ga4Id}`);
  if (analytics.callTrackingScript) addScript(analytics.callTrackingScript);
  trackPage(window.location.pathname);
};

export const track = (event, params = {}) => {
  if (hasWindow && loaded && window.gtag) window.gtag("event", event, params);
};

export const trackPage = (path) => {
  track("page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
};

// Calls, texts and review clicks, wherever they appear on the site.
// No personal data is sent — just the kind of action and the page it came from.
export const installClickTracking = () => {
  if (!hasWindow || window.__peplaClicks) return;
  window.__peplaClicks = true;
  document.addEventListener("click", (e) => {
    const a = e.target.closest && e.target.closest("a[href]");
    if (!a) return;
    const href = a.getAttribute("href") || "";
    const from = window.location.pathname;
    if (href.startsWith("tel:")) track("click_call", { link_location: from });
    else if (href.startsWith("sms:")) track("click_text", { link_location: from });
    else if (href.includes("google.com/maps") || href.includes("writereview")) track("click_google_reviews", { link_location: from });
    else if (href.startsWith("mailto:")) track("click_email", { link_location: from });
  }, { capture: true });
};
